export const SHOWSPORTSBATTLECONFIG = {
    "COLOR": {
        "main-color": "28A5C5",
        "secondary-color": "045662",
        "background-white": "ffffff",
        "text-black": "000000",
        "text-white": "ffffff",
        "border-color": "E4E5E5",
        "computer-start": "FF4F58",
        "myteam-btn-bg": "EAEAEA",
        "team-player-after-border": "0071BA",
        "computer-player-after-border": "D2145A",
        "betsliptbox-bg": "A4DBF2",
    }
};